
import { Component, Prop, Vue } from 'vue-property-decorator';
import Icon from '@/components/UI/Icon.vue';

@Component({
  components: {
    Icon,
  },
})
export default class CounterWithIcon extends Vue {
  @Prop({ type: Number, required: true, default: 0 }) public counter: number;
  @Prop({ type: String, required: true, default: 'mdi-check' }) public icon: string;
  @Prop({ type: String, required: false, default: 'black' }) public color: string;
  @Prop({ type: String, required: false, default: '' }) public colorIntensity: string;
  @Prop({ type: String, required: false, default: '' }) public colorIntensityHover: string;
}
